import Config from "./config.js";
import Launcher from "./launcher.js";

/**
 * Api — the 1Mind methods themselves. index.js composes these onto the object it publishes as
 * window.OneMind, so `this` is that object at call time (hence this.start / this.started).
 *
 * Usage, options and the one-per-page rule are documented in index.js.
 */
const Api = {
  Config,

  /** True once any call here started the experience. */
  started: false,

  /** Mount inline immediately. See "EMBEDDED" above. */
  embed(options = {}) {
    return this.start(options);
  },

  /** Start later with context. See "BEHIND THE FORM" above. */
  open(options = {}) {
    return this.start(options);
  },

  /**
   * Shared implementation behind embed() and open() — they differ only in intent and in the use
   * case a caller typically passes. (Legacy carried two identical copies of this.)
   */
  start(options) {
    if (this.started || Launcher.claimed()) {
      console.warn("[1mind] already running on this page — ignoring call");

      return false;
    }

    const mount = Launcher.mount(options.container);

    if (!mount) {
      console.warn("[1mind] container not found:", options.container);

      return false;
    }

    this.started = true;

    Launcher.inject({
      useCase: options.useCase || "embedded",
      env: options.env || Config.env,
      attributes: options.attributes,
    });

    Launcher.whenReady(options.onReady, options.onUnavailable);

    return true;
  },
};

export default Api;
